import {useMutation, useQueryClient} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

async function deleteLogoFn() {
  const {data} = await sdk.deleteLogo()
  return data || null
}

export function useDeleteLogo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteLogoFn,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['settings']})
    },
  })
}
